module.exports = __webpack_public_path__ + "img/album15_05.56a4f28f.jpg";